import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'findByDate'})
export class FindByDatePipe implements PipeTransform {
    transform<T extends { date: string }>(items: T[], date: string): T | undefined {
        return items?.find(item => item.date === date);
    }
}

